import React from 'react';

import { SendGiftConfirmationTemplate } from '@hero/components';

export default function SendGiftConfirmationPage() {
  return <SendGiftConfirmationTemplate />;
}
